import React, { useEffect, useState } from 'react'
import Button from '@components/common/form/Button'
import YSpacing from '@components/common/YSpacing'
import Panel from '@components/common/Panel'
import { MarketDropdown } from '@components/common/form'
import Loader from '@components/common/Loader'
import { Label } from '@res/styledComponents/index'

interface GroupOrderUniversalMenusReportsPageProps {
  loadHeadquarters: () => any[]
  triggerReport: (hqs: number[]) => void
}

const GroupOrderUniversalMenusReportsPage: React.FC<
  GroupOrderUniversalMenusReportsPageProps
> = ({ loadHeadquarters, triggerReport }) => {
  const [headquarters, setHeadquarters] = useState<any[]>([])
  const [selectedHqs, setSelectedHqs] = useState<number[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchHeadquarters = async () => {
    const hqs = await loadHeadquarters()
    if (hqs) {
      setHeadquarters([{ id: 0, name: 'All' }, ...hqs])
    }
  }

  useEffect(() => {
    fetchHeadquarters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSelectHq = (hqId: number) => {
    if (hqId == 0) {
      const nextHqs = headquarters.filter((h) => h.id !== 0).map((h) => h.id)
      setSelectedHqs(nextHqs)
    } else if (!selectedHqs.includes(hqId)) {
      setSelectedHqs([...selectedHqs, hqId])
    }
  }

  const onDeselectHq = (hqId: number) => {
    if (hqId == 0) {
      setSelectedHqs([])
    } else {
      const nextHqs = [...selectedHqs].filter((h) => h !== hqId)
      setSelectedHqs(nextHqs)
    }
  }

  const handleTriggerReport = async () => {
    setIsLoading(true)
    if (selectedHqs.length == 0) {
      return
    }
    await triggerReport(selectedHqs)
    setIsLoading(false)
  }

  return (
    <Panel width={'100%'} maxWidth={'500px'} heading="Universal Menus Report">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <YSpacing height="20px" />
          <MarketDropdown
            label="Market(s)"
            onSelectHq={onSelectHq}
            onDeselectHq={onDeselectHq}
            options={headquarters}
            selectedOptions={selectedHqs}
          />
          <YSpacing height="20px" />
          <YSpacing height="20px" />
          <Label>
            Create a CSV of all current universal menu configurations from
            client settings. Only client settings with a universal menu config
            will be added onto the CSV
          </Label>
          <Button
            disabled={selectedHqs.length === 0}
            onClick={handleTriggerReport}
            label={isLoading ? 'Loading...' : 'Create Report'}
          />
        </>
      )}
    </Panel>
  )
}

export default GroupOrderUniversalMenusReportsPage
